import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-070efeae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "AnswerCardContainer wd100 brd2"
};
const _hoisted_2 = {
  class: "boldFont"
};
const _hoisted_3 = {
  class: "boldFont"
};
const _hoisted_4 = {
  class: "boldFont"
};
const _hoisted_5 = {
  class: "ft20 boldFont",
  style: {
    "color": "#3269FF"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft12 mt8 light"
}, "答题剩余时间", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_progress = _resolveComponent("el-progress");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.width === 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "【第" + _toDisplayString($props.session.unitOrder) + "单元】答题进度", 1)]),
      _: 1
    })]),
    _: 1
  })) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$props.groupSize == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "共" + _toDisplayString($data.questions.length) + "题", 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_4, "共" + _toDisplayString($data.questions.length) + "组,每组" + _toDisplayString($props.groupSize) + "题", 1)]),
    _: 1
  }))], 64)), $props.width === 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "pd12",
    gutter: 10
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: qi
      }, [q ? (_openBlock(), _createBlock(_component_el_col, {
        key: 0,
        span: 8,
        class: "flex items-center mb10"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          class: _normalizeClass([q ? 'answered wd100' : 'notAnswer wd100'])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(qi + 1), 1)]),
          _: 2
        }, 1032, ["class"])]),
        _: 2
      }, 1024)) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "pd12",
    gutter: 10
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, (q, qi) => {
      return _openBlock(), _createBlock(_component_el_col, {
        key: qi,
        span: 8,
        class: "flex items-center mb10"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          class: _normalizeClass([q ? 'answered wd100' : 'notAnswer wd100'])
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(qi + 1), 1)]),
          _: 2
        }, 1032, ["class"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })), _createVNode(_component_el_row, {
    class: "flex items-center justify-center mt32"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_progress, {
      type: "circle",
      percentage: $data.timeEndPercent,
      "stroke-width": "10",
      color: "#165DFF"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "flex items-center justify-center flex flex-col"
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_5, _toDisplayString($data.examLeftTime), 1), _hoisted_6]),
        _: 1
      })]),
      _: 1
    }, 8, ["percentage"])]),
    _: 1
  })]);
}